import React from 'react';

export const PricingSkeleton = () => (
  <div
    data-testing-id='pricing-skeleton'
    className='pricing-skeleton flex column'
  >
    <div className='flex space-between'>
      <div>
        <span className='animated-skeleton'>{'_'.repeat(20)}</span>
      </div>
      <div>
        <span className='animated-skeleton'>{'_'.repeat(12)}</span>
      </div>
    </div>
    <div className='flex space-between'>
      <div>
        <span className='animated-skeleton'>{'_'.repeat(15)}</span>
      </div>
      <div>
        <span className='animated-skeleton'>{'_'.repeat(7)}</span>
      </div>
    </div>
    <div className='flex space-between'>
      <div>
        <span className='animated-skeleton'>{'_'.repeat(18)}</span>
      </div>
      <div>
        <span className='animated-skeleton'>{'_'.repeat(10)}</span>
      </div>
    </div>
    <hr className='summary-line' />
    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div>
        <span className='animated-skeleton dark'>{'_'.repeat(10)}</span>
      </div>
      <div>
        <span className='animated-skeleton dark'>{'_'.repeat(7)}</span>
      </div>
    </div>
  </div>
);
